import { render, staticRenderFns } from "./FrequencyTable.vue?vue&type=template&id=16fa9a4a&scoped=true&"
import script from "./FrequencyTable.vue?vue&type=script&lang=js&"
export * from "./FrequencyTable.vue?vue&type=script&lang=js&"
import style0 from "./FrequencyTable.vue?vue&type=style&index=0&id=16fa9a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fa9a4a",
  null
  
)

export default component.exports